import { useTracker } from '~/features/clickstream-sdk/composables/useTracker';
import { ETrackerActions, tracker } from '~/features/clickstream-sdk/ClickStreamTracker';
import type { IEventProperties } from '~/features/clickstream-sdk/models/eventProperties';

type TFavoritesContext = {
  block: string;
};

export function useFavoritesTracker(context: TFavoritesContext) {
  const { block } = context;

  const { track } = useTracker({ block });

  const trackAddToFavorites = (extra: Partial<IEventProperties> = {}) => {
    track({
      action: ETrackerActions.CLICK,
      element: 'favoritesAdd',
      ...extra,
    });
  };

  const trackRemoveFromFavorites = (extra: Partial<IEventProperties> = {}) => {
    track({
      action: ETrackerActions.CLICK,
      element: 'favoritesDelete',
      ...extra,
    });
  };

  const trackAddToFavoritesProductScreen = (extra: Partial<IEventProperties> = {}) => {
    tracker.trackWithEventName('market_productScreen_favoritesAdd_click', {
      action: ETrackerActions.CLICK,
      element: 'favoritesAdd',
      page: 'productScreen',
      chapter: 'market',
      block: 'unknown',
      ...extra,
    });
  };

  const trackRemoveFromFavoritesProductScreen = (extra: Partial<IEventProperties> = {}) => {
    tracker.trackWithEventName('market_productScreen_favoritesDelete_click', {
      action: ETrackerActions.CLICK,
      element: 'favoritesDelete',
      page: 'productScreen',
      chapter: 'market',
      block: 'unknown',
      ...extra,
    });
  };

  return {
    trackAddToFavorites,
    trackRemoveFromFavorites,
    trackAddToFavoritesProductScreen,
    trackRemoveFromFavoritesProductScreen,
  };
}
